module.exports = __webpack_public_path__ + "waxjet-510-main.png?6854f708c818c0d3d3fbd751f57368bd";